@if (slot) {
  <div class="flex flex-col gap-3 rounded-lg border border-slate-200 bg-white p-3">
    <app-board-v3-company-picker [slot]="slot" (slotChange)="setSlot($event)" />
    <div class="flex justify-end gap-2 border-t border-slate-100 pt-3">
      <app-button [btnType]="'cancel'" [disabled]="busy" (onChangeClick)="cancelEdit()">
        {{ 'cancel' | translate }}
      </app-button>
      <app-button [disabled]="busy" (onChangeClick)="save()">
        {{ (busy ? 'saving' : 'save') | translate }}
      </app-button>
    </div>
  </div>
} @else if (company) {
  <div
    class="group relative !flex w-full cursor-pointer items-start gap-3 rounded-lg bg-slate-50 px-3 py-2 pr-8 text-left transition hover:bg-slate-100"
    role="button"
    tabindex="0"
    [attr.aria-label]="'board_v3_company_edit' | translate"
    (click)="startEdit()"
    (keydown.enter)="startEdit()"
  >
    <span
      class="pointer-events-none absolute right-2 top-2 inline-flex h-8 w-8 items-center justify-center text-slate-400 opacity-0 transition group-hover:opacity-100"
    >
      <app-icon class="!h-4 !w-4 !text-[16px] !leading-none">edit</app-icon>
    </span>
    <span class="mt-0.5 grid h-8 w-8 shrink-0 place-items-center rounded-lg bg-white text-slate-500 ring-1 ring-slate-200">
      <app-icon class="!h-[18px] !w-[18px] !text-[18px] !leading-none">apartment</app-icon>
    </span>
    <div class="flex min-w-0 flex-1 flex-col gap-0.5">
      <button
        type="button"
        class="min-w-0 self-start truncate text-left text-sm font-semibold text-slate-900 hover:text-orange-600"
        (click)="$event.stopPropagation(); openCompany()"
      >
        {{ getCompanyName(company) }}
      </button>
      @for (phone of getCompanyPhones(company); track phone) {
        <a
          class="flex w-fit items-center gap-1 text-xs font-medium !text-slate-600 !no-underline hover:!text-slate-900"
          [href]="phoneHref(phone)"
          (click)="$event.stopPropagation()"
        >
          <app-icon class="!h-3.5 !w-3.5 !text-[14px] !leading-none text-slate-400">phone</app-icon>
          {{ formatContactPhone(phone) }}
        </a>
      }
      @for (email of getCompanyEmails(company); track email) {
        <a
          class="flex w-fit items-center gap-1 break-all text-xs font-medium !text-slate-600 !no-underline hover:!text-slate-900"
          [href]="'mailto:' + email"
          (click)="$event.stopPropagation()"
        >
          <app-icon class="!h-3.5 !w-3.5 !text-[14px] !leading-none text-slate-400">mail_outline</app-icon>
          {{ email }}
        </a>
      }
      @for (address of company.addresses ?? []; track $index) {
        <a
          class="flex w-fit items-start gap-1 break-words text-xs font-medium !text-slate-600 !no-underline hover:!text-slate-900"
          [href]="getAddressMapUrl(address)"
          target="_blank"
          rel="noopener noreferrer"
          (click)="$event.stopPropagation()"
        >
          <app-icon class="!h-3.5 !w-3.5 shrink-0 !text-[14px] !leading-none text-slate-400">location_on</app-icon>
          {{ formatAddress(address) }}
        </a>
      }
    </div>
    <button
      type="button"
      class="inline-flex h-8 w-8 shrink-0 items-center justify-center rounded text-slate-400 opacity-0 transition hover:bg-rose-50 hover:text-rose-600 focus:opacity-100 group-hover:opacity-100"
      [matTooltip]="'board_v3_contact_unlink' | translate"
      [disabled]="busy"
      (click)="$event.stopPropagation(); unlink()"
    >
      <app-icon class="!h-4 !w-4 !text-[16px] !leading-none">link_off</app-icon>
    </button>
  </div>
} @else {
  <button
    type="button"
    class="flex min-h-16 w-full items-center justify-center gap-1.5 rounded-lg! border border-dashed border-slate-200 text-sm font-medium text-slate-400 transition hover:border-orange-200 hover:bg-orange-50 hover:text-orange-600"
    (click)="startEdit()"
  >
    <app-icon class="!h-4 !w-4 !text-[16px] !leading-none">domain_add</app-icon>
    {{ 'board_v3_company_add' | translate }}
  </button>
}
